import React, { useState } from 'react';

const SearchFilter = ({ data, onFilter, type, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCriteria, setFilterCriteria] = useState('all');

  const handleSearch = (term) => {
    setSearchTerm(term);
    filterData(term, filterCriteria);
  };

  const handleFilter = (criteria) => {
    setFilterCriteria(criteria);
    filterData(searchTerm, criteria);
  };

  const filterData = (term, criteria) => {
    let filtered = data;

    if (term) {
      filtered = filtered.filter(item => {
        const searchField = type === 'class' ? item.class_name :
                          type === 'teacher' ? item.teacher_name :
                          item.student_name;
        return searchField.toLowerCase().includes(term.toLowerCase());
      });
    }

    if (criteria !== 'all') {
      switch (type) {
        case 'class':
          filtered = filtered.filter(item => item.class_level.toString() === criteria);
          break;
        case 'teacher':
          filtered = filtered.filter(item => {
            const subjects = Array.isArray(item.subjects) ? item.subjects : [item.subjects];
            return subjects.some(subject => subject === criteria);
          });
          break;
        case 'student':
          filtered = filtered.filter(item => 
            item.saas_classes?.class_name === criteria
          );
          break;
        default:
          break;
      }
    }

    onFilter(filtered);
  };

  const getFilterOptions = () => {
    switch (type) {
      case 'class':
        return [...new Set(data.map(item => item.class_level))].map(level => ({
          value: level.toString(),
          label: `年級 ${level}`
        }));
      case 'teacher':
        const allSubjects = data.flatMap(item => 
          Array.isArray(item.subjects) ? item.subjects : [item.subjects]
        );
        return [...new Set(allSubjects)].map(subject => ({
          value: subject,
          label: subject
        }));
      case 'student':
        return [...new Set(data.map(item => item.saas_classes?.class_name).filter(Boolean))].map(className => ({
          value: className,
          label: className
        }));
      default:
        return [];
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div className="sm:w-48">
          <select
            value={filterCriteria}
            onChange={(e) => handleFilter(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="all">全部</option>
            {getFilterOptions().map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;
